// import xlsxModule from 'xlsx';
// import fileSaver from 'file-saver';

// import * as _ from 'lodash';
// function Workbook() {
//     if (!(this instanceof Workbook)) return new Workbook();
//     this.SheetNames = [];
//     this.Sheets = {};
// }

export async function getXlsxAndFileSaver() {
    const xlsx = await import('xlsx');
    const fileSaver = await import('file-saver');
    return {
        xlsx,
        fileSaver
    }
}

export class Workbook {
    SheetNames:any = []
    Sheets:any = {};
}

export function s2ab(s:any) {
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
}


export async function download(filename:any, rows:any) {
    let {xlsx, fileSaver} = await getXlsxAndFileSaver();
    let wb = new Workbook();
    let ws = xlsx.utils.aoa_to_sheet(rows);
    wb.SheetNames.push('records');
    wb.Sheets['records'] = ws;
    let opts: any = {bookType: 'xlsx', bookSST: false, type: 'binary'};
    let bout = xlsx.write(wb, opts);

    let blob = new Blob([
        s2ab(bout)
    ], {
        type: 'application/octet-stream'
    })
    fileSaver.saveAs(blob, `${filename}.xlsx`);
}
